export default {
  // SEO title
  SEOTitleAllProducts: {
    id: 'review_display_all_reviews_meta_title',
    defaultMessage:
      'Is Back Market reputable? Read reviews for all our refurbished electronics',
  },
  SEOTitleMerchantProducts: {
    id: 'review_display_merchant_meta_title_new',
    defaultMessage: '{merchantName} Customer Reviews',
  },

  // SEO description
  SEODescriptionAllProducts: {
    id: 'review_display_all_reviews_meta_description_new',
    defaultMessage:
      'Wondering if Back Market services are reliable? Are prices a scam? Overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  SEODescriptionMerchantProducts: {
    id: 'review_display_merchant_meta_description_new',
    defaultMessage:
      'Wondering if a seller on Back Market - {merchantName} - is reliable? Are their refurbished electronics of good quality? Our overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
} as const
